module.exports = __webpack_public_path__ + "static/uxanddigitalexperience-a26b4a6b272a3c82db75ec17ac619f0c.png";